import { post, get } from '@/helpers/http'
import config from '@/helpers/config.js'
import utility from '@/helpers/utility'

const state = {
  appInitialized: false,
  verificationHash: false,
  registrationEmail: false,
  appStatus: 'default',
  appLoading: true,
  embedLoading: true,
  isDownloadingImage: false,
  requestingAccess: false,
  settingsInitialized: false,
  currentYear: false,
  settings: {
    'user': {},
    'search': {
      'view': 'search',
      'sort': 'relevance'
    },
    'datasets': {
      'page': 1,
      'sort': '-published',
      'display': 'grid_sm',
      'access': 'all'
    },
    'pdfs': {
      'page': 1,
      'sort': '-published',
      'display': 'list',
      'access': 'all'
    },
    'news': {
      'page': 1,
      'sort': '-published',
      'display': 'list',
      'access': 'all',
      'before_id': false,
      'after_id': false
    },
    'dataset': {
      'display': 'bar_ver'
    }
  },
  defaultSettings: {
    'user': {},
    'search': {
      'view': 'search'
    },
    'datasets': {
      'page': 1,
      'sort': '-published',
      'display': 'grid_sm',
      'access': 'all'
    },
    'pdfs': {
      'page': 1,
      'sort': '-published',
      'display': 'list',
      'access': 'all'
    },
    'news': {
      'page': 1,
      'sort': '-published',
      'display': 'list',
      'access': 'all',
      'before_id': false,
      'after_id': false
    },
    'dataset': {
      'display': 'bar_ver'
    }
  }
}

const getters = {
  getAppInitialized (state) { return state.appInitialized },
  getVerificationHash (state) { return state.verificationHash },
  getRegistrationEmail (state) { return state.registrationEmail },
  getAppLoading (state) { return state.appLoading },
  getEmbedLoading (state) { return state.embedLoading },
  getAppStatus (state) { return state.appStatus },
  getIsDownloadingImage (state) { return state.isDownloadingImage },
  getRequestingAccess (state) { return state.requestingAccess },
  getSettings (state) { return state.settings },
  getDefaultSettings (state) { return state.defaultSettings },
  getDefaultSort (state, getters, rootState, rootGetters) {
    let selectedFiltersCount = Object.keys(rootState.search.selectedFilters).length
    return selectedFiltersCount > 0 ? 'relevance' : '-published'
  },
  getCurrentYear (state) { return state.currentYear },
}

const actions = {
  async initialize ({ state, commit, dispatch, rootState }) {
    let response = await get('client/initialize')

    if (response.data.data.user && response.data.data.user !== false) {
      let status = response.data.data.user.attributes.subscription_status

      dispatch('user/setState', response.data.data.user, {root:true})
      dispatch('user/refreshState', response.data.data.user.attributes, {root:true})
      dispatch('user/setSubscriptionStatus', status, {root:true})
      dispatch('user/fetchSettings', false, {root:true})
      dispatch('user/fetchNotifications', false, {root:true})
      utility.sendGoogleAnalyticsEvent('auth_logged', false, false, rootState.user.subscriptionStatus)
    } else {
      dispatch('user/setLoginState', false, {root:true})
    }

    commit('SET_CURRENT_YEAR', response.data.data.current_year)
    commit('SET_APP_INITIALIZED', true)
  },

  async setRegistrationInfo ({ commit }, hash) {
    try {
      let response = await post('users/verify', { 'verification_hash': hash })

      if (response.data.data.email && response.data.data.verification_hash) {
        commit('SET_REGISTRATION_EMAIL', response.data.data.email)
        commit('SET_VERIFICATION_HASH', response.data.data.verification_hash)

        return true
      }
    } catch (error) {
      return false
    }
  },

  async newsletter ({ commit }, formData) {
    let response = await post('client/newsletter', formData)
    return response.data
  },

  setAppInitialized ({ commit }, status) {
    commit('SET_APP_INITIALIZED', status)
  },

  setAppLoading ({ commit }, value) {
    commit('SET_APP_LOADING', value)
  },

  setEmbedLoading ({ commit }, value) {
    commit('SET_EMBED_LOADING', value)
  },

  setAppStatus ({ commit }, status) {
    commit('SET_APP_STATUS', status ? status : 'default')
  },

  setVerificationHash ({ commit }, value) {
    commit('SET_VERIFICATION_HASH', value)
  },

  setRegistrationEmail ({ commit }, value) {
    commit('SET_REGISTRATION_EMAIL', value)
  },

  setIsDownloadingImage ({ commit }, value) {
    commit('SET_IS_DOWNLOADING_IMAGE', value)
  },

  setRequestingAccess ({ commit }, value) {
    commit('SET_REQUESTING_ACCESS', value)
  },

  setSettings ({ commit, rootState }, settings) {
    let newSettings = { ...rootState.app.settings }
    let newItems = Array.isArray(settings) ? settings : [settings]

    newItems.forEach(setting => {
      let parts = setting.name.split('.')
      let mainSetting = parts[0]
      let subSetting = parts[1]

      newSettings[mainSetting][subSetting] = setting.value
    })

    commit('SET_SETTINGS', newSettings)
  }
}

const mutations = {
  SET_APP_LOADING (state, value) {
    state.appLoading = value
  },
  SET_EMBED_LOADING (state, value) {
    state.embedLoading = value
  },
  SET_APP_INITIALIZED (state, value) {
    state.appInitialized = value
  },
  SET_VERIFICATION_HASH (state, value) {
    state.verificationHash = value
  },
  SET_REGISTRATION_EMAIL (state, value) {
    state.registrationEmail = value
  },
  SET_APP_STATUS (state, value) {
    state.appStatus = value
  },
  SET_IS_DOWNLOADING_IMAGE (state, value) {
    state.isDownloadingImage = value
  },
  SET_REQUESTING_ACCESS (state, value) {
    state.requestingAccess = value
  },
  SET_SETTINGS (state, value) {
    state.settings = value
  },
  SET_CURRENT_YEAR (state, value) {
    state.currentYear = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
